import { connect } from 'react-redux';
import {
  onSetLocationErrors,
  setSelectedLocation,
} from '../../../../actions/orders';
import { setTimeZone } from '../../../../actions/settings';
import LocationSelect from './LocationSelect';
import { customSelectStyles } from '../../../../utilities/helperUtility';

export default connect(
  ({
    product = {},
    order = {},
    frames = {},
    settings: {
      bookingToken,
      setting = {},
      style = {},
      translation = {},
      defaultTranslation = {},
    },
  }) => ({
    kind: 'locations',
    locations: product.data ? product.data.locations : [],
    selectedLocation: order.selectedLocation || null,
    errors: order.locationValidationErrors,
    setting,
    styles: customSelectStyles(style.select, !!order.locationValidationErrors),
    translation,
    bookingToken,
    defaultTranslation,
    isDisabled: frames.loading || frames.isFetchingBlocks,
  }),
  (dispatch) => ({
    onSetErrors: (e) => dispatch(onSetLocationErrors(e)),
    setSelected: (location) => dispatch(setSelectedLocation(location)),
    setTimeZone: (timeZone) => dispatch(setTimeZone(timeZone)),
  }),
)(LocationSelect);
